const graphics = {
  airplane: {
    element: "path",
    svgElementProps: {
      d: "M26.748,94h10l22.438-40H85c0,0,15,0,15-7s-15-7-15-7H59.186L36.748,0h-10l12.438,40H21.251L10,30H0l8,17L0,64h10 l11.252-10h17.935L26.748,94z",
    },
    svgProps: {
      viewBox: "0 0 100 94",
    },
  },
  circle: {
    element: "circle",
    svgElementProps: {
      cx: 16,
      cy: 16,
      r: 16,
    },
    svgProps: {
      viewBox: "0 0 32 32",
    },
  },
  dashedLine: {
    element: "path",
    style: { height: "2px", lineHeight: "2px", width: "fit-content" },
    svgElementProps: {
      d: "M0,0 L179,0",
      stroke: "danger-500",
      strokeDasharray: "12 8 30 12 6 22",
      strokeDashoffset: 0,
    },
    svgProps: {
      height: 2,
      viewBox: "0 0 90 2",
      width: 90,
    },
  },
  heart: {
    element: "path",
    svgElementProps: {
      d: "M4.375 1.875C2.64938 1.875 1.25 3.26 1.25 4.96875C1.25 6.34812 1.79688 9.62188 7.18 12.9313C7.27643 12.9899 7.38713 13.021 7.5 13.021C7.61287 13.021 7.72357 12.9899 7.82 12.9313C13.2031 9.62188 13.75 6.34812 13.75 4.96875C13.75 3.26 12.3506 1.875 10.625 1.875C8.89938 1.875 7.5 3.75 7.5 3.75C7.5 3.75 6.10062 1.875 4.375 1.875Z",
    },
    svgProps: {
      viewBox: "0 0 15 15",
    },
  },
  line: {
    element: "path",
    svgElementProps: {
      d: "M5,5 L27,5",
      stroke: "neutral-300",
      strokeLinecap: "round",
      strokeWidth: 10,
    },
    svgProps: {
      height: 32,
      viewBox: "0 0 32 32",
      width: 32,
    },
  },
  rectangle: {
    element: "rect",
    svgElementProps: {
      height: 32,
      strokeWidth: 5,
      width: 32,
    },
    svgProps: {
      viewBox: "0 0 32 32",
    },
  },
};

export { graphics };
